import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "margin-t-b" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "field-data"
}
const _hoisted_4 = { class: "text-subtitle-1 font-weight-bold secondary--text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "field-data text-subtitle-1 font-weight-bold",
  style: {"text-decoration":"underline"}
}
const _hoisted_7 = { class: "d-inline-block ltr font-weight-bold" }
const _hoisted_8 = { class: "text-subtitle-2 font-weight-bold" }
const _hoisted_9 = { class: "d-inline-block ltr" }
const _hoisted_10 = { class: "text-subtitle-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_treeview = _resolveComponent("v-treeview")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFlexibleILOs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.ilos && Object.keys(_ctx.ilos).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('ILOS')) + " : ", 1),
                _createVNode(_component_v_treeview, {
                  items: _ctx.ilos as any[],
                  class: "wrappable-tree",
                  "open-all": "",
                  open: _ctx.openNodes,
                  "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => (_ctx.openNodes = $event))
                }, {
                  prepend: _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(item.ilo_code) + " ) ", 1)
                  ]),
                  _: 1
                }, 8, ["items", "open"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ilos, (ilosArray, headerKey) => {
            return (_openBlock(), _createElementBlock("div", {
              key: headerKey,
              class: "field-data"
            }, [
              (ilosArray && ilosArray.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$utils.servertranslate(ilosArray[0].header)), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ilosArray, (ilo, iloIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: iloIndex,
                  class: "field-data px-2"
                }, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(ilo.iloCode), 1),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _createElementVNode("span", _hoisted_8, ") " + _toDisplayString(ilo.ilo), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ilo.subIlos || [], (sub, subIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: subIndex,
                      class: "field-data"
                    }, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(sub.subIloCode), 1),
                      _cache[1] || (_cache[1] = _createTextVNode()),
                      _createElementVNode("span", _hoisted_10, ") " + _toDisplayString(sub.subIlo), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ]))
          }), 128))
        ]))
  ]))
}